import { useMemo } from "react";
import PropTypes from "prop-types";

import { t } from "../../services";
import { strCode } from "../../consts";

import { LoginPageTemplate } from "../../templates";
import {
  FlexContainers,
  Input,
  SmallButton,
  TextButton,
  WrapperContainer
} from "../../components";

const SimpleLogin = ({
  username,
  password,
  setUsername,
  setPassword,
  hasError,
  isLoading,
  onLogin,
  onForgotPassword,
  onSingleSignOn
}) => {
  const disabled = useMemo(() => {
    return isLoading || username.length <= 2 || password.length < 8;
  }, [isLoading, username, password]);

  return (
    <LoginPageTemplate
      title={t(strCode.SIMPLE_LOGIN_TITLE)}
      description={t(strCode.SIMPLE_LOGIN_DESCRIPTION)}>
      <WrapperContainer mb={12}>
        <Input
          id={t(strCode.USERNAME_TITLE)}
          title={t(strCode.USERNAME_TITLE)}
          value={username}
          setValue={setUsername}
          placeholder={t(strCode.USERNAME_PLACEHOLDER)}
          hasError={hasError}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !disabled) {
              onLogin();
            }
          }}
        />
      </WrapperContainer>

      <WrapperContainer mb={32}>
        <Input
          id={t(strCode.PASSWORD_TITLE)}
          title={t(strCode.PASSWORD_TITLE)}
          value={password}
          setValue={setPassword}
          placeholder={t(strCode.PASSWORD_PLACEHOLDER)}
          hasError={hasError}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !disabled) {
              onLogin();
            }
          }}
          isPassword
        />
      </WrapperContainer>

      <SmallButton onClick={onLogin} disabled={disabled} loading={isLoading} fullWidth>
        {t(strCode.CONTINUE_BTN)}
      </SmallButton>

      <WrapperContainer Container={FlexContainers.FlexColumnCenter} gap={16} mt={22}>
        {onSingleSignOn && (
          <TextButton disabled={isLoading} onClick={onSingleSignOn}>
            {t(strCode.SINGLE_SIGN_ON_BTN)}
          </TextButton>
        )}

        <TextButton disabled={isLoading} onClick={onForgotPassword}>
          {t(strCode.FORGOT_PASSWORD_BTN)}
        </TextButton>
      </WrapperContainer>
    </LoginPageTemplate>
  );
};

SimpleLogin.propTypes = {
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  setUsername: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
  onSingleSignOn: PropTypes.func,
  onForgotPassword: PropTypes.func.isRequired
};

export default SimpleLogin;
